module.exports = __webpack_public_path__ + "f6fb3cb0cd413ca68d0d650b7fb8d578.jpg";